import styled from 'styled-components';
import imgR from '../../../images/bg_hero.png';



export const Wrapper = styled.div`
  background: url(${imgR}) center right no-repeat, #ede6de;
  background-size: 65vw;
  color: #2E305D;
`;